import { Component, OnInit } from '@angular/core';

import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PdfLibraryService } from '@summit/services';

@Component({
  templateUrl: './s-form-pdf-preview-dialog.component.html',
  styleUrls: ['./s-form-pdf-preview-dialog.component.css'],
  standalone: true,
  imports: [NgxExtendedPdfViewerModule]
})
export class SFormPdfPreviewDialogComponent implements OnInit {
  constructor(
    public dialogRef: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private pdfLibraryService: PdfLibraryService
  ) {
    //console.log('Dialog config', dialogConfig);
  }

  async ngOnInit(): Promise<void> {
    // Use CDN with fallback to local assets for better performance and reliability
    // Service tries multiple CDNs and falls back to local if all fail
    pdfDefaultOptions.assetsFolder = await this.pdfLibraryService.getPdfViewerAssetsFolder();
  }

  onEvent(_event: string, _data: any) {
    //console.log(event, data);
  }
}
